import { NgModule } from '@angular/core';
import { DeleteCompanyReportService } from './delete-company-report';
import { DownloadReportService } from './download-report.service';
import { GenerateReportService } from './generate-report';
import { GenerateReportPreviewService } from './generate-report-preview.service';
import { GenerateTransientReportPreviewService } from './generate-transient-report-preview.service';
import { GetCompanyReportService } from './get-company-report.service';
import { GetCompanyReportsService } from './get-company-reports.service';
import { ReportCenterService } from './report-center.service';
import { SetCompanyReportService } from './set-company-report.service';

@NgModule({
    providers: [
        ReportCenterService,
        GetCompanyReportsService,
        DeleteCompanyReportService,
        GetCompanyReportService,
        SetCompanyReportService,
        GenerateReportPreviewService,
        GenerateTransientReportPreviewService,
        GenerateReportService,
        DownloadReportService
    ]
})
export class ReportCenterModule {}
